export enum EHardwareMode {
  ALL_IN_ONE = 1,
  PC = 2
}
